import React, { useEffect, useState } from "react";
import { ApiURL } from "../../../../../services/apiConstants";
import { post } from "../../../../../services/services";
import SisLoader from "../../../../../widgets/loader";
import LNGCargoCompressorDetailsTable from "../../components/CargoCraneCom/LngCargoCompressorRow";

function StaffLNGCargoCompressor({ id }) {
  const [loader, setLoader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const fetchLNGCargoCompressorList = async () => {
    setLoader(true);
    const formData = new FormData();
    formData.append("ship_id", id);

    try {
      const res = await post(ApiURL.list_cargo_machinery_lng_st, formData);
      if (res?.status === true) {
        setFilteredData(res?.lng_cargo_parameters_data || []);
      }
    } catch (error) {
      console.error("Error fetching LNG Cargo Compressor list:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchLNGCargoCompressorList();
  }, []);

  return (
    <>
      <h3 style={{ margin: "15px 0", fontWeight: "600" }}>LNG Cargo Compressor Information</h3>
      {loader ? (
        <SisLoader />
      ) : filteredData.length > 0 ? (
        <LNGCargoCompressorDetailsTable data={filteredData} />
      ) : (
        <p>No data available</p>
      )}
    </>
  );
}

export default StaffLNGCargoCompressor;
